import type { IsoDateTime } from '@omnipresentgroup/design-system';

export enum MergeMagicLinkStatus {
  REDACTED = 'REDACTED',
  EXPIRED = 'EXPIRED',
}

export enum MergeIntegrationStatus {
  INIT = 'INIT',
  LINK_GENERATED = 'LINK_GENERATED',
  LINK_GENERATED_BUT_NOT_INTEGRATED = 'LINK_GENERATED_BUT_NOT_INTEGRATED',
  AUTH_GRANTED = 'AUTH_GRANTED',
  TOKEN_GRANTED_BUT_NOT_INTEGRATED = 'TOKEN_GRANTED_BUT_NOT_INTEGRATED',
  ACCOUNT_SYNCED = 'ACCOUNT_SYNCED',
}

export enum MergeIntegrationEmployeeStatus {
  NOT_CHECKED = 'NOT_CHECKED',
  OK = 'OK',
  MISSING_MERGE = 'MISSING_MERGE',
  MISSING_OP = 'MISSING_OP',
  CLIENT_AUTH_FAILURE = 'CLIENT_AUTH_FAILURE',
  DUPLICATE_MERGE = 'DUPLICATE_MERGE',
  DUPLICATE_OP = 'DUPLICATE_OP',
  INVALID = 'INVALID',
}

export type MergeIntegrationEmployee = {
  id: string;
  firstName: string;
  lastName: string;
  workEmail: string;
  syncStatus?: MergeIntegrationEmployeeStatus;
  lastEventAt?: IsoDateTime;
};

export type MergeIntegration = {
  enabled: boolean;
  status?: MergeIntegrationStatus;
  companyId: string;
  integrationName?: string;
  icon?: {
    image?: string;
    squareImage?: string;
  };
  magicLinkUrl?: string | MergeMagicLinkStatus;
  employees: MergeIntegrationEmployee[];
};

export type MergeIntegrationLink = {
  mergeMagicLinkUrl: string;
  mergeMagicLinkUrlExpiryAt: IsoDateTime;
};

export type SyncCompanyTimeOffRequest = { startDate: string };
